export default {"src":"/_next/static/media/bonus_points.b21743c6.svg","height":112,"width":103,"blurWidth":0,"blurHeight":0};